import type { LocationDescriptor } from 'history';

export interface MtApplicationCheckoutFailedPageData {
  applicationsLink: LocationDescriptor;
}

export interface MtApplicationCheckoutFailedPageProps extends MtApplicationCheckoutFailedPageData {}
